<template>
  <div
    v-if="hasRoles('R&D', 'HRL')"
    class="q-pa-md"
  >
    <!-- <div class="row">
      <q-space />
      <q-btn
        class="q-ma-md"
        label="Create new template"
        color="primary"
        to="/emailWysiwyg"
        no-caps
      />
    </div> -->
    <q-table
      title="Email Templates"
      :rows="emailTemplates"
      :columns="emailColumns"
      row-key="emailTemplateId"
      :visible-columns="visibleColumns"
      :rows-per-page-options="[10, 25, 50, 100, 200]"
      no-data-label="NoTemplates found with given search criteria"
      binary-state-sort
    >
      <template v-slot:top-right>
        <q-btn
          icon-right="add"
          class="q-mr-xs"
          color="primary"
          @click="onCreate()"
        />
        <q-btn
          class="q-mr-xs"
          color="primary"
          icon-right="archive"
          no-caps
          @click="exportEmailHistory"
        />
        <q-btn
          v-if="hasRoles('R&D')"
          icon-right="sync"
          class="q-mr-xs"
          color="primary"
          label="Generate System Emails"
          no-caps
          @click="onGenerateSystemEmailTemplates"
        />
        <q-dialog
          ref="editModal"
          v-model="isEmailModalActive"
          persistent
        >
          <q-card style="width: 700px; max-width: 700px;">
            <EmailWysiwyg ref="emailWysiwyg" />
            <!-- <q-card-actions
              align="center"
              class="bg-white text-teal"
            >
              <q-btn
                label="Send Test Email"
                color="primary"
                @click="onSendTestEmail()"
              />
              <q-btn
                flat
                label="Cancel"
                v-close-popup
                color="primary"
              />
              <q-btn
                flat
                label="Save"
                @click="submitForm()"
              />
            </q-card-actions> -->
          </q-card>
        </q-dialog>
      </template>
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            {{ col.label }}
          </q-th>
          <q-th>
            Edit
          </q-th>
          <q-th>
            Delete
          </q-th>
        </q-tr>
      </template>

      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            <span v-if="col.label === 'Subject'">
              <span v-html="col.value"></span>
            </span>
            <span v-else>
              <span v-if="col.name === 'Manual Send'">
                {{ $filters.yesNo(col.value) }}
              </span>
              <span v-else>
                {{ col.value }}
              </span>
            </span>
          </q-td>
          <q-td>
            <q-btn
              @click="onEdit(props.row.emailTemplateId)"
              class="q-mr-xs"
              size="sm"
              color="white"
              text-color="primary"
              round
              flat
              icon="edit"
            />
          </q-td>
          <q-td>
            <q-btn
            v-if="props.row.emailTemplateType === 'ManualSend'"
              @click="isDeleteModal = true; deleteId = props.row.emailTemplateId"
              class="q-mr-xs"
              size="sm"
              color="white"
              text-color="primary"
              round
              flat
              icon="delete"
            />
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <q-dialog
      v-model="isDeleteModal"
      >
      <q-card
        align="left"
        style="width: 550px; max-width: 80vw;"
      >
        <div class="q-ma-lg">
          You are about to delete an email template.
          Are you sure you want to continue?
        </div>
        <q-card-actions
          align="center"
          class="bg-white text-positive"
        >
          <q-btn
            flat
            label="Close"
            v-close-popup
          />
          <q-btn
            color="primary"
            flat
            label="Confirm"
            v-close-popup
            @click="onDelete(deleteId)"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { defineExpose, ref } from 'vue';
import { useQuasar } from 'quasar';
import useAuth from '@/hooks/auth';
import useEmailTemplate from '@/hooks/email';
import useUtility from '@/hooks/utility';
import useUiUtilities from '@/utilities/uiUtilities';
import EmailWysiwyg from './EmailWysiwyg.vue';

const $q = useQuasar();
const { hasRoles } = useAuth();
const {
  deleteEmailTemplate,
  emailTemplates,
  getAllEmailTemplates,
  getEmailTemplate,
  isEmailModalActive,
  generateSystemEmailTemplates,
} = useEmailTemplate();
const { createDownloadableFile } = useUiUtilities();
const { getEmailHistoryExport } = useUtility();

// const isEmailModalActive = ref(false);
const isDeleteModal = ref(false);
const emailWysiwyg = ref(null);
const editModal = ref(null);
const deleteId = ref(0);

// const submitForm = async () => {
//   const response = await emailWysiwyg.value.onSubmit();
//   if (response?.status === 200 || response?.status === 201) {
//     $q.loading.show();
//     isAddModal.value = false;
//     emailTemplates.value = await getAllEmailTemplates();
//     $q.loading.hide();
//   }
// };

// const $q = useQuasar();
await getAllEmailTemplates();

const onEdit = async (id) => {
  await getEmailTemplate(id);
  isEmailModalActive.value = true;
};
const onCreate = () => {
  isEmailModalActive.value = true;
};
const onDelete = async (id) => {
  await deleteEmailTemplate(id);
};

const onGenerateSystemEmailTemplates = async () => {
  await generateSystemEmailTemplates();
};
// const onSendTestEmail = async () => emailWysiwyg.value.onSubmitTestEmail();

const exportEmailHistory = async () => {
  try {
    $q.loading.show();
    const result = await getEmailHistoryExport();
    createDownloadableFile(result, 'email_history_export.csv', 'text/csv;charset=utf-8;');
    $q.loading.hide();
  } catch (error) {
    console.log(error);
  }
};

const emailColumns = [
  {
    name: 'Name', align: 'left', label: 'Name', field: (row) => row.emailTemplateName, sortable: true,
  },
  {
    name: 'From', align: 'left', label: 'From', field: (row) => row.from,
  },
  {
    name: 'Manual Send', align: 'left', label: 'Manual Send', field: (row) => row.emailTemplateType === 'ManualSend',
  },
  {
    name: 'Subject', align: 'left', label: 'Subject', field: (row) => row.subject,
  },
  {
    name: 'To', align: 'left', label: 'To', field: (row) => (row.to.length <= 1 ? row.to[0] : row.to.join(', ')),
  },
  {
    name: 'Cc', align: 'left', label: 'Cc', field: (row) => row.cc.join(', '),
  },
  {
    name: 'Bcc', align: 'left', label: 'Bcc', field: (row) => row.bcc.join(', '),
  },
  {
    name: 'Body', align: 'right', label: 'Body', field: (row) => row.body,
  },
];

const visibleColumns = ref(['Name', 'From', 'Manual Send', 'Subject', 'To', 'Cc', 'Bcc']);

// eslint-disable-next-line
defineExpose({ editModal, emailWysiwyg, hasRoles });
</script>
